if (!customElements.get('video-email-optin')) {
  customElements.define('video-email-optin', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('form').addEventListener('submit', event => this.submit(event));
      this.querySelector('.video-email-optin__close').addEventListener('click', () => this.hide());
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.hide();
      });
    }
    async submit(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.submitting) return;
      const form = this.querySelector('form');
      if (!form.reportValidity()) return;
      const status = this.querySelector('.video-email-optin__status');
      const button = form.querySelector('button[type="submit"]');
      this.submitting = true;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      status.hidden = false;
      status.textContent = this.dataset.pending;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Subscription request failed');
        const result = await response.json();
        if (result.status === 'quarantined' || result.consent?.enabled) {
          status.textContent = this.dataset.verification;
        } else if (result.status === 'success') {
          form.hidden = true;
          status.textContent = this.dataset.success;
          status.focus();
        } else {
          status.textContent = this.dataset.error;
        }
      } catch {
        status.textContent = this.dataset.error;
      } finally {
        clearTimeout(timeout);
        this.submitting = false;
        button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    }
    show() {
      if (this.dismissed || !this.isConnected) return;
      const quickShopScroll = this.closest('.quick-shop-52kards')?.querySelector('[data-quick-shop-scroll]');
      if (quickShopScroll) {
        quickShopScroll.scrollTop = 0;
        const gallerySlider = this.closest('slider-element');
        if (gallerySlider) gallerySlider.scrollTop = 0;
      }
      this.closest('.product__media')?.classList.add('video-email-optin--visible');
      this.hidden = false;
    }
    hide() {
      this.hidden = true;
      this.closest('.product__media')?.classList.remove('video-email-optin--visible');
      this.dismissed = true;
      this.closest('.product__media')?.querySelector('iframe')?.focus();
    }
  });
}
